
const initialState = {
	isLoggedIn: false,
	ready_for_code: false,
	error_message: false,
    user_id: false,
    user_email: false,
    user_password: false,
    availableRoutes: false,
    user_inactive_logout: false,
    childUsers: false,
    user_password_success: false,
    user_token: false,
    user_verified: false,
    user_ctoken: false,
    user_profile: {
    	selectedRepresentativeUserId: false
    }
}

export const UserReducer = (state = initialState, action = {}) => {
    let childUsers = state.childUsers;

   switch (action.type) {
         /*case 'persist/REHYDRATE':
            return action.payload ? action.payload.userReducer ? action.payload.userReducer : state : state;*/
		case 'USER_AGREED_TO_TERMS':

			 return {
				...state,
				user_profile: {
					...state.user_profile,
					accepted_terms: "1"
				}
			}
        case 'USER_FETCH_DATA_SUCCESS':
        	return {
                ...state,
                ready_for_code: action.userData.ready_for_code
            }

        case 'SET_USER_EMAIL':
            return {
                ...state,
                user_email: action.payload
            }

        case 'SET_USER_PASSWORD':
            return {
                ...state,
                user_password: action.payload
            }

        case 'SET_USER_CTOKEN':

                return {
                    ...state,
                    user_ctoken: action.payload
        }

        case 'USER_SET_INACTIVE_LOGOUT':
            return {
                ...state,
                user_inactive_logout: action.payload
            }
        case 'USER_PASSWORD_SUCCESS':
            return {
                ...state,
                user_password_success: action.payload
            }
        case 'USER_VERIFIED':
            return {
                ...state,
                user_email: false,
                user_password: false,
                user_verified: action.userData.user_verified,
                user_id: action.userData.user_id,
                user_token: action.userData.user_token,
                user_profile: action.userData.userProfile
            }
         case 'USER_UPDATED':
            return {
                ...state,
                user_profile: action.userData
            }

        case 'USER_HAS_ERRORED':
        	return {
                ...state,
                error_message: action.errorMessage
            }
        case 'USER_RESET':
            return {
                ...state,
                ready_for_code: false,
                isLoggedIn: false
            }

        case 'USER_IS_LOADING':
            return {
                ...state,
            }

        case 'USER_ROUTES_FETCH_SUCCESS':
                return {
                    ...state,
                    availableRoutes: action.payload.routes,
                    profileRoutes: action.payload.profileRoutes
                }

        case 'CHILD_USERS_FETCHED':
            return {
                ...state,
                childUsers : action.userData
            }
        case 'CHILD_USER_UPDATED':

            childUsers[action.payload.userIndex] = action.payload.userData;

            return {
                ...state,
                childUsers : childUsers

            }
        case 'CHILD_USER_CREATED':

            childUsers.push(action.payload.userData);

            return {
                ...state,
                childUsers : childUsers

            }

        case 'USER_ROUTES_LOADING':
            return {
                ...state,
            }

        case 'USER_ROUTES_HAVE_ERRORED':
            return {
                ...state,
            }


        case 'DESTROY':
            return initialState;


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/UserReducer.js